import React, { useRef, useState } from "react";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay";

// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper";

// install Swiper modules
SwiperCore.use([Pagination, Navigation, Autoplay]);

export default function App() {
    return (
        <>

            <section


            >
                <div className="section-sp1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">

                                <div style={{ margin: "0 auto", maxWidth: "570px" }}>
                                    <h1 className="title-head text-center">Rotary Club</h1>
                                    <Swiper
                                        slidesPerView={1}
                                        loop={true}
                                        autoplay={{
                                            delay: 2500,
                                            disableOnInteraction: false,
                                        }}
                                        pagination={{
                                            clickable: true,
                                        }}
                                        className="mySwiper"
                                    >
                                        <SwiperSlide>
                                            {/* <a
                                    href={"/result/jee-advanced-2021"}
                                > */}

                                            <img src="https://reliablekota.com/mission-vriksh/4.jpg" />

                                            {/* </a> */}
                                        </SwiperSlide>
                                        <SwiperSlide>


                                            <img src="https://reliablekota.com/mission-vriksh/5.jpg" />


                                        </SwiperSlide>
                                        <SwiperSlide>


                                            <img src="https://reliablekota.com/mission-vriksh/7.jpg" />

                                        </SwiperSlide>
                                        <SwiperSlide>


                                            <img src="https://reliablekota.com/mission-vriksh/8.jpg" />


                                        </SwiperSlide>
                                        <SwiperSlide>


                                            <img src="https://reliablekota.com/mission-vriksh/9.jpg" />


                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <img src="https://reliablekota.com/mission-vriksh/10.jpg" />
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <img src="https://reliablekota.com/mission-vriksh/11.jpg" />
                                        </SwiperSlide>
                                        <SwiperSlide>
                                            <img src="https://reliablekota.com/mission-vriksh/12.jpg" />
                                        </SwiperSlide>



                                    </Swiper>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
